import { LinkOutlined } from '@ant-design/icons';
import { App as AntApp, Button, theme } from 'antd';

export const CopyLinkButton = () => {
  const { message } = AntApp.useApp();
  const { token } = theme.useToken();

  const copy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      message.success('Link copied');
    } catch {
      message.error(`Could not copy — ${url}`);
    }
  };

  return (
    <Button type="text" icon={<LinkOutlined />} onClick={copy} style={{ color: token.colorTextTertiary }}>
      Copy link
    </Button>
  );
};
